import { Box, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ButtonZoom } from "../../../v2/utils/ButtonZoom";
import React from "react";
import { ErrorToast, SuccessToast } from "../../../v2/utils/Toast";
import { HandleDataLayer } from "../../../../Helpers";

interface ClassCodeProps {
  classCode: String | null;
}

const useStyle = makeStyles((theme) => ({
  classCodeCard: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    border: "2px solid #E8E8E8",
    borderRadius: "8px",
    padding: "24px",
    width: "auto",
    height: "278px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "16px",
  },
}));

export const ClassCodeCard = (props: ClassCodeProps) => {
  const classes = useStyle();
  return (
    <>
      <Box className={classes.classCodeCard}>
        <Stack flexDirection="row" alignItems="center" gap={"20px"}>
          <i className={`fal fa-key fa-lg`}></i>
          <Typography
            variant="body1"
            sx={{
              font: "normal normal 600 20px/27px proxima-soft !important",
              letterSpacing: "0.15px",
              color: "#191919",
            }}>
            Class code
          </Typography>
        </Stack>
        <Typography
          variant="body1"
          sx={{ font: "normal normal normal 14px/21px Roboto" }}>
          Share the class join code with your students so they can register for Digit as
          part of your class.
        </Typography>
        <Box
          sx={{
            background: "#FAFAFA 0% 0% no-repeat padding-box",
            border: "2px solid #E8E8E8",
            borderRadius: "4px",
            height: "71px",
            width: "100%",
            padding: "16px 51px",
          }}>
          <Typography
            variant="body1"
            sx={{
              font: "normal normal 300 30px/48px Roboto Mono",
              letterSpacing: "12px",
              margin: "-9px",
            }}>
            {props.classCode}
          </Typography>
        </Box>
        <Stack flexDirection={"row"} justifyContent={"center"} gap={"8px"}>
          <Box
            sx={{
              background: "#FFFFFF 0% 0% no-repeat padding-box",
              border: "1px solid #E8E8E8",
              borderRadius: "4px",
              width: "210px",
              height: "34px",
              display: "flex",
              flexDirection: "row",
            }}>
            <Box sx={{ padding: "5px 8px", width: "34px" }}>
              <i className={`fal fa-link fa-sm`}></i>
            </Box>
            <Box
              sx={{
                background: "#FAFAFA 0% 0% no-repeat padding-box",
                borderRadius: "0px 4px 4px 0px",
                height: "34px",
                width: "176px",
              }}>
              <Typography
                variant="body1"
                sx={{
                  font: "normal normal normal 14px/21px Roboto",
                  letterSpacing: "0px",
                  color: "#5D5D5D",
                  textAlign: "left",
                  padding: "6px 0px",
                  marginLeft: "6px",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}>
                {process.env.REACT_APP_BACKEND_API?.replace("api.", "")}
                /self-registration?code=
                {props.classCode}
              </Typography>
            </Box>
          </Box>
          <ButtonZoom
            disableZoom={true}
            size={"small"}
            variant="outlined"
            onClick={() => {
              HandleDataLayer(
                "link",
                "click",
                "internal link",
                "main content",
                "class code",
                "copy link",
                "onclick"
              );
              navigator.clipboard
                .writeText(
                  `${process.env.REACT_APP_BACKEND_API?.replace(
                    "api.",
                    ""
                  )}/self-registration?code=${props.classCode}`
                )
                .then(() => {
                  SuccessToast("Copied link to clipboard");
                })
                .catch((err) => {
                  ErrorToast("Failed to copy link to clipboard");
                });
            }}
            sx={{
              minWidth: "112px",
              height: "34px",
              borderRadius: "8px",
              fontSize: "16px",
            }}>
            Copy Link
          </ButtonZoom>
        </Stack>
      </Box>
    </>
  );
};
